import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.95.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/Carousel/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/InfoBar/InfoBar.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/ui/Tags/Chip.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/ui/Tags/TagList.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/ui/layout/DetailsView/DetailsView.module.scss");
